export default __webpack_public_path__ + "static/media/servicies_desktop.bg.c84ff7b6.png";